const applicationProfileMixin = {
    data() {
        return {
            application: { id: this.$route.params.id || '' },
            RESOURCE_EKYZMAT_ID: 1,
            RESOURCE_LOCAL_POSITIONS_ID: 2,
            RESOURCE_NRK_ID: 3,
        }
    },
    methods: {
        fetchApplication( applicationId ) {
            return this.axios.get( this.$config.urls.application.fetchApplication.url.replace( ':id', applicationId ) )
                       .then( response => {
                           this.application = response.data.data;
                           return response.data.data;
                       } )
        },
        
        createTestingEvent( applicationId, form ) {
            return this.axios.post( this.$config.urls.application.createEvent.url.replace( ':id', applicationId ), form )
                       .then( response => {
                           this.application = response.data.data;
                           return response.data.data;
                       } )
        }
    }
};
export default applicationProfileMixin;